<template>
    <v-card class="pa-4">
        <v-card-title>
            Новая модель
            <v-spacer></v-spacer>
            <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
            <v-form autocomplete="off" @submit.prevent="save">
                <v-text-field
                    v-model="item.name"
                    label="Название модели"
                ></v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large color="primary" @click="save" :disabled="!isValid">Далее</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import clone from "lodash.clonedeep";

export default {
    props: ['value'],
    data() {
        return {
            item: clone(this.value),
            analysisType: null,
            ACTION_LOAD: 'problem/loadItems',
            ACTION_NEW: 'problem/newItem',
            ACTION_SAVE: 'problem/saveItem',
            ACTION_SET_EDIT_ITEM: 'problem/setEditItem',
            ROUTE_LIST: 'problemsList',
            STORE_MODULE: 'problem'
        }
    },
    watch: {
        value() {
            if (!this.value) {
                this.item = {};
            }
        },
        item: {
            deep: true,
            handler() {
                this.$emit('input', this.getProcessedItem());
            }
        }
    },
    methods: {
        getProcessedItem() {
            let item = Object.assign({}, this.item);
            item.name = item.name?.trim() || '';
            return item;
        },
        async save() {
            this.$emit('save', this.getProcessedItem());
        },
        close() {
            this.$emit('close');
        }
    },
    computed: {
        isValid() {
            return this.item.name && this.item.name.trim() !== '';
        }
    }
}
</script>

<style scoped>

</style>